export default function About() {
  const stats = [
    { number: '20+', label: 'Years Leadership Experience' },
    { number: '20+', label: 'Organizations Advised' },
    { number: '100%', label: 'Mission-Driven Focus' }
  ];

  return (
    <section id="about" className="py-24 bg-[#1a2b4a] text-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-white/80 text-base font-light tracking-wide">About Jerilyn</span>
          <h2 className="text-4xl lg:text-5xl font-bold mt-4 mb-12" style={{ fontFamily: 'Crimson Text, serif' }}>
            Leadership, Strategy, and Organizational Transformation
          </h2>
        </div>

        <div className="grid md:grid-cols-5 gap-8 mb-16">
          <div className="md:col-span-2 flex justify-center items-start">
            <div className="w-full max-w-xs rounded-2xl overflow-hidden shadow-2xl border border-white/20">
              <img
                src="https://lh3.googleusercontent.com/sitesv/APaQ0STHpWN-XmZ_VEuTnxtK9PyqZp_HCNM1pF9GAlwOt2-e7pjDEtP81UO1PdXBuD20Kx66lXeJMLUoCsWkMLS6dTGF_mT4RRwS-xpIJUHTMyCXwTBsAmfU5MAiWB1jQA0Vusy8tCpM_X9UgQTJZxfeJm4T6xYuS2l_e3jtoqYgoLh7QceMUU_P2JTj0-30y4AouoLgGYM_2U5XuNnhqfRJLfqepZvwt8Vy4Pkrc8U=w1280"
                alt="Jerilyn Emerson - Organizational Strategist & Executive Coach"
                className="w-full h-auto object-top"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="md:col-span-3 space-y-6">
            <p className="text-lg leading-relaxed text-white/90">
              Jerilyn Emerson is an organizational strategist and executive coach who works with nonprofit and social impact leaders navigating complex organizational change. She brings more than 20 years of experience helping mission-driven organizations strengthen leadership teams, align strategy with operations, and build people systems that support lasting impact.
            </p>
            <p className="text-lg leading-relaxed text-white/90">
              Jerilyn previously served as Chief Operating Officer, Chief People &amp; Culture Officer, and Chief of Staff at Greenpeace USA,&nbsp;where she led major organizational transformation across people, operations, and strategy within one of the world’s most recognized environmental organizations. Her experience spans executive leadership, organizational design, talent strategy, and cross-functional operations.
            </p>
            <p className="text-lg leading-relaxed text-white/90">
              Today, Jerilyn partners with executives and leadership teams to navigate change, strengthen leadership capacity, and create the conditions for organizations to deliver on their mission with clarity and impact.&nbsp; Certified Executive and Organizational Development Coach | DiSC | Birkman | CliftonStrengths
            </p>
            <p className="text-lg leading-relaxed text-white/90">
              Jerilyn's work is grounded in the belief that strong leadership, aligned strategy, and thoughtful organizational design are essential for mission-driven organizations seeking lasting impact.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="border border-white/30 rounded-2xl p-8 text-center hover:border-[#2d9b9b] transition-colors duration-300"
            >
              <div className="text-5xl font-bold text-[#2d9b9b] mb-3">{stat.number}</div>
              <div className="text-sm text-white/90">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}